import { Row } from "@tanstack/react-table";

// TST default arrIncludesSome filterFn does not support null value
// We need null value support for initial filter state
export function tstArrIncludesSomeFilterFn<T>(
    row: Row<T>,
    id: string,
    filterValue: string[] | null
) {
    if (!filterValue || filterValue.length === 0) {
        return true;
    }
    return filterValue.includes(row.getValue(id));
}
